import type {SenseAction} from 'src/action-creators/types';

import {
  OPEN_PANEL,
  CLOSE_PANEL,
  OPEN_MENU_PANEL,
  STORE_MENU_PANEL_STATE,
} from 'src/action-creators/chat/panels';


export type State = {
  isPanelOpen: boolean;
  isActionPanel: boolean;
  isMenuOpen: boolean;
  menuPanelStateToRestore: boolean;
};

const initialState = () => ({
  isPanelOpen: false,
  isActionPanel: false,
  isMenuOpen: false,
  menuPanelStateToRestore: false,
});

export default function reduce(
  state: State | null | undefined = initialState(),
  action: SenseAction,
): State {
  switch (action.type) {
    case OPEN_MENU_PANEL: {
      // @ts-expect-error - TS2322 - Type '{ isMenuOpen: boolean; isPanelOpen?: boolean | undefined; isActionPanel?: boolean | undefined; menuPanelStateToRestore?: boolean | undefined; }' is not assignable to type 'State'.
      return {
        ...state,
        isMenuOpen: action.payload.value,
      };
    }

    case STORE_MENU_PANEL_STATE: {
      // @ts-expect-error - TS2322 - Type '{ menuPanelStateToRestore: boolean; isPanelOpen?: boolean | undefined; isActionPanel?: boolean | undefined; isMenuOpen?: boolean | undefined; }' is not assignable to type 'State'.
      return {
        ...state,
        menuPanelStateToRestore: action.payload.value,
      };
    }
    case OPEN_PANEL: {
      const {isActionPanel} = action.payload;

      // @ts-expect-error - TS2322 - Type '{ isPanelOpen: true; isMenuOpen: false; isActionPanel: boolean; menuPanelStateToRestore?: boolean | undefined; }' is not assignable to type 'State'.
      return {
        ...state,
        isPanelOpen: true,
        isMenuOpen: false,
        isActionPanel,
      };
    }

    case CLOSE_PANEL: {
      // @ts-expect-error - TS2322 - Type '{ isPanelOpen: false; isActionPanel: false; isMenuOpen?: boolean | undefined; menuPanelStateToRestore?: boolean | undefined; }' is not assignable to type 'State'.
      return {
        ...state,
        isPanelOpen: false,
        isActionPanel: false,
      };
    }
  }

  // @ts-expect-error - TS2322 - Type 'State | null' is not assignable to type 'State'.
  return state;
}
